import { render, staticRenderFns } from "./ThreeScene.vue?vue&type=template&id=286b8cb2&scoped=true"
import script from "./ThreeScene.vue?vue&type=script&lang=js"
export * from "./ThreeScene.vue?vue&type=script&lang=js"
import style0 from "./ThreeScene.vue?vue&type=style&index=0&id=286b8cb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286b8cb2",
  null
  
)

export default component.exports